<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-1"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <div v-bind:style="{'z-index': '4'}" class="layout-row pa-1">
        <div class="layout-row">
          <lx-dropdown-button small
                              hide-list-icons
                              icon="refresh"
                              tooltip="Ansicht aktualisieren"
                              :items="refreshItems"
                              @click="getData">
          </lx-dropdown-button>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden">
        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px"
             :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1); overflow-y: auto" class="flex layout-column">

            <v-container>
              <v-row no-gutters>
                <v-col>
                  <doughnut-chart
                    v-if="loaded"
                    :chartdata="chartDataOs"
                    :options="optionsOs"/>
                </v-col>
                <v-col>
                  <doughnut-chart
                    v-if="loaded"
                    :chartdata="chartDataWeb"
                    :options="optionsWeb"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="layout-row layout-align-center-center">
                    <bar-chart
                      v-if="loaded"
                      :chartdata="chartDataFrontend"
                      :options="optionsFrontend"
                      class="flex-50"/>
                  </div>
                </v-col>
              </v-row>
            </v-container>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '../../../components/charts/BarChart'
import DoughnutChart from '../../../components/charts/DoughnutChart'
import LxDropdownButton from '../../../components/lx_dropdown_button/LxDropdownButton'

function toChartData (input, label) {
  if (!Array.isArray(input)) return null

  const colors = ['#00A000', '#FFCD56', '#B30000', '#00A0A0', '#777777', '#B30000', '#AAAAAA']
  let labels = []
  let data = []
  let bgcolors = []
  let borders = []

  let addAlpha = (color, opacity) => {
    // coerce values so ti is between 0 and 1.
    const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + _opacity.toString(16).toUpperCase();
  }

  input.forEach((item, index) => {
    labels.push(item.name)
    data.push(item.count)

    borders.push(addAlpha(colors[(index % 5)], 1))
    bgcolors.push(addAlpha(colors[(index % 5)], 0.7))
  })
  return {
    labels: labels,
    datasets: [
      {
        label: label,
        borderColor: borders,
        backgroundColor: bgcolors,
        hoverBackgroundColor: borders,
        data: data
      },
    ]
  }
}

export default {
  name: 'MonitoringMetadataDetails',
  components: { DoughnutChart, BarChart, LxDropdownButton },
  data () {
    return {
      loaded: false,
      selectedPeriodValue: 1,
      refreshItems: [
        { caption: 'Letzten 24 Stunden', value: 1, default: true },
        { caption: 'Letzten 7 Tage', value: 7 },
        { caption: 'Letzten 30 Tage', value: 30 },
        { caption: 'Letzten 60 Tage', value: 60 },
        { caption: 'Gesamter Zeitraum', value: -1 }
      ],
      chartDataOs: null,
      chartDataWeb: null,
      chartDataFrontend: null,
      optionsOs: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Betriebssysteme'
        }
      },
      optionsWeb: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Webbrowser'
        }
      },
      optionsFrontend: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }]
        },
        title: {
          display: true,
          text: 'Frontend Versionen'
        }
      }
    }
  },
  async mounted () {
    this.getData()
  },
  methods: {
    getData (event, selectedPeriod) {
      this.loaded = false

      // set value of selectedPeriodValue, if getData was triggered by selection
      if (selectedPeriod) this.selectedPeriodValue = selectedPeriod

      this.$http.get('monitoring/metadata/' + this.selectedPeriodValue)
        .then(res => {
          if (res.data) {
            this.chartDataOs = toChartData(res.data.os || {}, 'Betriebssysteme')
            this.chartDataWeb = toChartData(res.data.web || {}, 'Webbrowser')
            this.chartDataFrontend = toChartData(res.data.frontend || {}, 'Frontend Versionen')

            setTimeout(() => {
              this.loaded = true
            }, 100)
          }
        })
        .catch(this.NotifyError)
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'MonitoringMetadataDetails') {
        this.getData()
      }
    }
  }
}
</script>
